import BoxStatus from "@components/BoxStatus";
import { USERS_MODIFY, USER_DETAIL } from "@constants/routes";
import { timestampToString } from "@helpers/dates.format";
import { ICurrentUser } from "@interfaces/Core/Authentication/currentUser";
import { IUser } from "@interfaces/Core/Users/user";
import { generatePath, Link } from "react-router-dom";
import { Button } from "reactstrap";

const listUserMapper = (
  usersFromApi: IUser[],
  handleActionDeleteUser: Function,
  currentUser: ICurrentUser | null
) => {
  const listUser = usersFromApi.map(
    ({ uuid, name, lastname, username, mail, createdAt, state }, index) => ({
      order: index + 1,
      uuid,
      name,
      lastname,
      username,
      mail,
      createDate: timestampToString(createdAt),
      _createDateTs: createdAt ?? 0,
      state: <BoxStatus state={state} />,
      actions: (
        <>
          <Link to={generatePath(USER_DETAIL, { uuid: uuid })}>
            <Button className="btn-sm btn-primary">
              <span className="lnr lnr-user" />
            </Button>
          </Link>
          <Link to={generatePath(USERS_MODIFY, { uuid: uuid })}>
            <Button className="btn-sm btn-warning">
              <span className="lnr lnr-pencil" />
            </Button>
          </Link>
          <Button
            className={`btn-sm ${
              currentUser?.uuid === uuid
                ? "btn-secondary btn-disabled"
                : "btn-danger"
            }`}
            onClick={() => {
              currentUser?.uuid !== uuid &&
                handleActionDeleteUser({
                  uuid,
                  description: mail,
                });
            }}
          >
            <span className="lnr lnr-trash" />
          </Button>
        </>
      ),
    })
  );

  return listUser;
};

export default listUserMapper;
